type NotifyMeFlags = { c_isNotifyme?: boolean; c_disableNotifyMe?: boolean };

/**
 * Whether the catalog enables Notify Me for a product: `c_isNotifyme` is set by the daily feed and
 * `c_disableNotifyMe` is the merchandiser override. Stock is the caller's concern.
 */
export const isNotifyMeEnabled = (product: object | null | undefined): boolean => {
    const flags = product as NotifyMeFlags | null | undefined;
    return flags?.c_isNotifyme === true && flags.c_disableNotifyMe !== true;
};
